












































































































import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"

@Component({
  computed: {
    ...mapState("QuestionGroup", {
      questionGroup: "questionGroup",
    }),
  },
})
export default class QuestionTransfer extends Vue {
  questionGroup!: Model

  drawer = false

  selectedLeft = []
  selectedRight = []

  librarySearch = ""
  displaySearch = ""

  get sortedImpactedTargets() {
    return this.questionGroup.impacted_targets
      .filter((item) => {
        const displaySearch = this.displaySearch.toLowerCase()
        return (
          item.bridge.body.toLowerCase().includes(displaySearch) ||
          (item.bridge.internal_annotation &&
            item.bridge.internal_annotation.toLowerCase().includes(displaySearch))
        )
      })
      .sort((a, b) => a.display_order - b.display_order)
  }

  get sortedLibrary() {
    return this.questionGroup.library
      .filter((item) => {
        const librarySearch = this.librarySearch.toLowerCase()
        return (
          item.bridge.body.toLowerCase().includes(librarySearch) ||
          (item.bridge.internal_annotation &&
            item.bridge.internal_annotation.toLowerCase().includes(librarySearch))
        )
      })
      .sort()
      .reverse()
  }

  transfer(direction) {
    this.$store
      .dispatch("QuestionGroup/transfer", {
        objectId: this.$route.params.questionGroupOid,
        payload: {
          questions:
            direction === "ltr" ? this.selectedLeft : this.selectedRight,
          direction,
        },
      })
      .then(() => {
        this.selectedLeft = []
        this.selectedRight = []
      })
  }

  isAvailable(item) {
    return (
      this.questionGroup.impacted_targets.findIndex(
        (impactedTarget) =>
          impactedTarget.bridge.object_id === item.bridge.object_id
      ) === -1
    )
  }

  isInternalAnnotationExisted(question) {
    if (!question) {
      return false
    }

    if (!question.internal_annotation) {
      return false
    }

    if (!question.internal_annotation.length) {
      return false
    }

    return true
  }
}
